import { render, staticRenderFns } from "./wine-case.vue?vue&type=template&id=24b563a7"
import script from "./wine-case.vue?vue&type=script&lang=js"
export * from "./wine-case.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports